const organizationId = "4aa8a744-a403-47fa-9689-5bc5e7deaf7d";
const token = "678c207d-073a-41d2-942b-1ed3dd3c667e";

let form;
let dataTable;

const params = new URLSearchParams(window.location.search);
shortId = params.get("tkcsid");

document.addEventListener("DOMContentLoaded", function () {
  if (window.assetId) {
    addPlayerToSlider();
    addVideoToSlider();
    addTextForFirstImg();
    fetchDataFromThreekitTable();
    validatedData();
    onEmailSending();

    if (!shortId) {
      changePlayerByFirstDownload();
    } else {
      getOptiionsFromThreekitWithShortID(shortId);
    }
  }
});

const onEmailSending = () => {
  const buttonForEmailSending = document.querySelector(
    ".product-form__buttons"
  );

  buttonForEmailSending.addEventListener(
    "mousedown",
    getSelectedOptionsForEmail
  );

  buttonForEmailSending.addEventListener(
    "touchstart",
    getSelectedOptionsForEmail
  );
};

const fetchDataFromThreekitTable = async () => {
  const URL = `https://admin-fts.threekit.com/api/datatables/${window.mapTableId}/rows?orgId=${organizationId}&bearer_token=${token}&all=true`;

  await fetch(URL, {
    method: "GET",
  })
    .then((res) => res.json())
    .then((res) => (dataTable = res));

  return dataTable;
};

const validatedData = async () => {
  const configuration = {};
  form = new FormData($("#product-form-installment")[0]);

  if (dataTable === undefined) {
    dataTable = await fetchDataFromThreekitTable();
  }

  dataTable.rows.forEach((row) => {
    if (
      form.get([row.value.shopify_options_name]) ===
      row.value.shopify_options_value
    ) {
      configuration[row.value.threekit_attr_name] =
        row.value.threekit_attr_value;
    }
  });

  return configuration;
};

const changePlayerByFirstDownload = async () => {
  let configuration;
  if (window.assetId) {
    if (!shortId) {
      configuration = await validatedData();
    } else {
      configuration = await getValuesFromThreekitByShortID(shortId);
    }
    setTimeout(() => {
      if (window.player) {
        const configurator = window.player?.getConfigurator();		
        configurator.then(function (configurator) {
          configurator.setConfiguration(configuration).then(() => {});
        });
      }
    }, 2000);
  }
};

const getValueByClick = async () => {
  let configuration = {};

  $(document).on("change.threekit", function (e) {
    form = new FormData($("#product-form-installment")[0]);

    if (dataTable) {
      dataTable.rows.forEach((row) => {
        if (
          form.get([row.value.shopify_options_name]) ===
          row.value.shopify_options_value
        ) {
          configuration[row.value.threekit_attr_name] =
            row.value.threekit_attr_value;
        }
      });
    }
    sendValueToThreekit(configuration);
  });
  return configuration;
};

const sendValueToThreekit = async (configuration) => {
  let shortId;

  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      orgId: organizationId,
      productId: window.assetId,
      productVersion: "exampleVersionNumber",
      variant: {
        configuration,
      },
      metadata: configuration,
    }),
  };

  await fetch(
    `https://admin-fts.threekit.com/api/configurations?bearer_token=${token}`,
    options
  )
    .then((response) => response.json())
    .then((response) => (shortId = response.shortId))
    .catch((err) => console.error(err));
  //console.log(configuration, "configuration what I send");
  return shortId;
};

const getValuesFromThreekitByShortID = async (shortId) => {
  const params = new URLSearchParams(window.location.search);
  params.set("tkcsid", shortId);

  let configuration;
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  };
  await fetch(
    `https://admin-fts.threekit.com/api/configurations?bearer_token=${token}?id=${shortId}`,
    options
  )
    .then((response) => response.json())
    .then((response) => {
      const product = response.configurations.find((el) => {
        return (el.shortId = shortId);
      });
      configuration = product.metadata;

      // console.log(configuration, "configuration what I get from Threekit");
      return configuration;
    })
    .catch((err) => console.error(err));

  return configuration;
};

$(document).on("change.threekit", async function (e) {
  let configuration;
  configuration = await validatedData();

  if (window.player) {
    const configurator = window.player.getConfigurator();
    configurator.then(function (configurator) {
      configurator.setConfiguration(configuration).then(() => {});
    });
  }
});

const getOptiionsFromThreekitWithShortID = async (shortId) => {
  const configuration = await getValuesFromThreekitByShortID(shortId);
  makeSwatchOnFormChecked(configuration);
  changePlayerByFirstDownload();
};

const validatedDataFromThreekitToShopify = async (configuration) => {
  let configurationForForm = {};

  if (configuration) {
    dataTable.rows.forEach((row) => {
      for (const [key, value] of Object.entries(configuration)) {
        if (
          row.value.threekit_attr_name === key &&
          row.value.threekit_attr_value === value
        ) {
          configurationForForm[row.value.shopify_options_name] =
            row.value.shopify_options_value;
        }
      }
    });
  }
  return configurationForForm;
};

const makeSwatchOnFormChecked = async (configuration) => {
  const configurationForForm = await validatedDataFromThreekitToShopify(
    configuration
  );

  const labels = document.querySelectorAll(
    ".bcpo-front-button-label, .bcpo-front-image-label, .bcpo-front-color-label"
  );

//   const labels = document.querySelectorAll(
//     ".threekit-preview-modal .bcpo-front-button-label, .threekit-preview-modal .bcpo-front-image-label, .threekit-preview-modal .bcpo-front-color-label"
//   );

  const dropDownOtions = document.querySelectorAll("select");
  const colorSwatches = document.querySelectorAll(".bcpo-colors");

  dropDownOtions.forEach((dropDownOtion) => {
    dropDownOtion.childNodes.forEach((option) => {
      for (const value of Object.values(configurationForForm)) {
        if (option.value === value) {
          option.selected = true;
          if (option.selected) {
            dropDownOtion.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }

        colorSwatches.forEach((swatch) => {
          if (swatch.value === value) {
            swatch.childNodes.forEach((el) => {
              el.style.display = "block";
            });
          }
        });
      }
    });
  });

  labels.forEach((label) => {
    const input = label.previousElementSibling;
    for (const [key, value] of Object.entries(configurationForForm)) {
      if (input.value === value && input.name === key) {
        label.click();
		console.log('clicked');
      }
    }
  });
  return;
};

const shareUrlLabels = document.querySelectorAll(".threekit_share");

const getUrl = async () => {
  let newUrl;
  const configuration = await validatedData();
  const shortId = await sendValueToThreekit(configuration);
  const playerId = params.get("tkcsid");

  if (!playerId) {
    newUrl = window.location.href + "?tkcsid=" + `${shortId}`;
  } else {
    const url = window.location.href.toString().split("?");
    newUrl = url[0] + "?tkcsid=" + `${shortId}`;
  }

  shareUrlLabels.forEach((label) => {
    label.textContent = newUrl;
    label.value = newUrl;
  });
};

const shareBtns = document.querySelectorAll(".threekit_share_btn");
shareBtns.forEach((btn) => {
  btn.addEventListener("click", getUrl);
});

// sending email started

const getSelectedOptionsForEmail = async () => {
  let options = [];
  let results;

  const interiorCamera = await createImgRoofHide("For Skreen");
  const exteriorCamera = await createImgRoofShow("MainFrame");

  const exteriorImg = {
    name: "Exterior",
    value: exteriorCamera,
  };

  const interiorImg = {
    name: "Interior",
    value: interiorCamera,
  };

  const coopName = {
    name: "Coop Style & Size",
    value: window.coopName,
  };

  options.push(interiorImg, exteriorImg, coopName);

  if (window.player) {
    let interiorLayout = {};

    for (let [name, value] of form) {
      let optionsValue = {};
      let nameValidated = name.split("[")?.slice(1);
      let valueValidated = value.split("(");
      if (nameValidated.length > 0) {
        nameValidated = nameValidated[0].split("").slice(0, -1).join("");
        optionsValue.name = nameValidated;
        optionsValue.value = valueValidated[0].trim();
      }

      options.push(optionsValue);

      results = options.filter((element) => Object.keys(element).length !== 0);
    }

    results.forEach((result) => {
      if (result.value.trim() === "All Chicks - Left Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksLeft;
      }
      if (result.value.trim() === "All Chicks - Right Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksRight;
      }
      if (result.value.trim() === "4'x4' Chicks & Peeps - Left Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeeps4x4Left;
      }
      if (result.value.trim() === "4'x4' Chicks & Peeps - Right Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeeps4x4Right;
      }
      if (result.value.trim() === "5'x3' Chicks & Peeps - Left Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeeps5x3Left;
      }
      if (result.value.trim() === "5'x3' Chicks & Peeps - Right Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeeps5x3Right;
      }
      if (result.value.trim() === "Chicks & Peeps & Auto Door - Left Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeepsLeft;
      }
      if (result.value.trim() === "Chicks & Peeps & Auto Door - Right Run") {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeepsRight;
      }
      if (
        result.value.trim() === "Chicks & Peeps - Left Run" ||
        result.value.trim() === "Chicks & Sprouts - Left Run"
      ) {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeepsLeft;
      }
      if (
        result.value.trim() === "Chicks & Peeps - Right Run" ||
        result.value.trim() === "Chicks & Sprouts - Right Run"
      ) {
        interiorLayout.name = "Interior Layout Img";
        interiorLayout.value = window.chicksAndPeepsRight;
      }
    });

    results.push(interiorLayout);
  }
  window.localStorage.setItem("Coops Info", JSON.stringify(results));
  return;
};

const createImgRoofShow = async (cameraName) => {
  const cameraData = await window.player.scene.getAll({
    hierarchical: true,
    name: cameraName,
  });

  const cameraObj = Object.values(cameraData);
  const cameraId = cameraObj.find((camera) => camera.type === "Camera");

  let imgSrc = await window.player.snapshotAsync({
    size: { width: 512, height: 512 },
    mimeType: "image/png",
    cameraId: cameraId.id,
  });

  // const form = document.querySelector(".product__info-wrapper");
  // let image = new Image();

  // image.src = imgSrc;

  // form.appendChild(image);

  return imgSrc;
};

const createImgRoofHide = async (cameraName) => {
  const cameraData = await window.player.scene.getAll({
    hierarchical: true,
    name: cameraName,
  });

  const cameraObj = Object.values(cameraData);
  const cameraId = cameraObj.find((camera) => camera.type === "Camera");

  const roof = await window.player.scene.filterNodes({
    hierarchical: true,
    tags: ["Roof"],
  });

  roof.forEach((id) => {
    window.player.scene.set(
      {
        hierarchical: true,
        id: id,
        plug: "Properties",
        property: "visible",
      },
      false
    );
  });

  let imgSrc = await window.player.snapshotAsync({
    size: { width: 512, height: 512 },
    mimeType: "image/png",
    cameraId: cameraId?.id,
  });

  roof.forEach((id) => {
    window.player.scene.set(
      {
        hierarchical: true,
        id: id,
        plug: "Properties",
        property: "visible",
      },
      true
    );
  });

  // const form = document.querySelector(".product__info-wrapper");
  // let image = new Image();
  // image.src = imgSrc;

  // form.appendChild(image);

  return imgSrc;
};

const addVideoToSlider = function () {
  const imgForVideo = document.querySelectorAll(`img[src*="imgvideo"]`);

  const imgForVideoArray = Array.from(imgForVideo);

  imgForVideoArray.map((el) => {
    const linkForVideo = el.parentElement;
    linkForVideo?.setAttribute("href", window.video);

    return;
  });
};

const addTextForFirstImg = function () {
  const firstSliderImg = document.querySelectorAll(`div[data-slick-index="0"]`);
  const textForFirstSliderImg = document.createElement("h3");

  if (window.assetId) {
    if ($(window).width() < 800) {
      //textForFirstSliderImg.textContent = "Scroll below to Design Your Coop!";
    }

    textForFirstSliderImg.style.textAlign = "center";
    firstSliderImg[0].append(textForFirstSliderImg);
    return;
  }
};

const addPlayerToSlider = () => {
  const firstSliderImgWrapper = document.querySelectorAll(
    `div[data-slick-index="0"]`
  );
  const firstSliderImg =
    firstSliderImgWrapper[0]?.querySelector(".sliderbig_img");

  const buttonForEmailSending = document.querySelector(".pdf");
  if (window.assetId) {
    buttonForEmailSending.style.display = "block";
  }

  const sliderNav = document.getElementsByClassName("slider-nav");

  const mainPage = document.querySelector(".page__main");
  const productInfoContainer = document.querySelector(".chloe");
  const reviewsSection = document.querySelector('.shopify-block.shopify-app-block.r--featured-section');
  mainPage?.appendChild(productInfoContainer);

  if (reviewsSection){
	const newChloe  = document.querySelector(".chloe");
	newChloe.insertBefore(reviewsSection, newChloe.firstChild);

  }

  if (sliderNav[0]) {
    if (sliderNav[0].childElementCount === 1) {
      sliderNav[0].style.display = "none";
    } else sliderNav[0].style.display = "block";
  }

  const threekitPlayer = document.querySelector(".threekitPlayer");
  const sliderImgSmall = document.querySelectorAll(".slider_img");

  sliderImgSmall.forEach((img) => {
    if (img.currentSrc === window.img360View) {
    //   img.style.width = "124px";
    //   img.style.margin = "auto";
    }
  });

  if (threekitPlayer && window.assetId) {
    //firstSliderImg.parentElement.append(threekitPlayer);
    //firstSliderImg.parentElement.removeChild(firstSliderImg);
  }
};
